module.exports = __webpack_public_path__ + "static/img/houqingyichang2.b69fc726.png";